import { render, staticRenderFns } from "./DeleteServiceModal.vue?vue&type=template&id=206dae58"
import script from "./DeleteServiceModal.vue?vue&type=script&lang=js"
export * from "./DeleteServiceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports